class RedisCacheController {
  /* @ngInject */
  constructor($log, $http, $interval, Redis, Users, Auth, Endpoints) {
    Object.assign(this, {
      $log,
      $http,
      $interval,
      Users,
      Redis,
      Auth,
      Endpoints,
      results: [],
      selected: {},
      selectedCount: 0,
      allSelected: false,
      searchString: ""
    });
    this.getRedisCache();
  }

  getRedisCache() {
    let roles = {};
    this.$http.get(this.Endpoints.users.me).then(({
      data
    }) => {
      for (var key in data.roles) {
        roles[key] = data.roles[key];
      }

      this.Redis.getRedisCache(roles).then(({
        data
      }) => {
        let dataArr = [];

        for (var key in data) {
          dataArr.push({
            key,
            value: data[key],
            selected: false
          });
        }

        this.results = dataArr;
      }).catch(err => {
        this.results = [];
        this.$log.error(err);
      });
    });
  }

  select(row) {
    if (row['selected'] === false) {
      row['selected'] = true;
    } else {
      row['selected'] = false;
    }

    this.selectedCount = 0;
    this.filteredResults.forEach(result => {
      if (result['selected']) this.selectedCount++;
    });

    if (this.filteredResults.length && this.selectedCount === this.filteredResults.length) {
      this.allSelected = true;
    } else {
      this.allSelected = false;
    }
  }

  selectAll() {
    if (!this.allSelected) {
      this.filteredResults.forEach(result => {
        result['selected'] = true;
      });
      this.allSelected = true;
      this.selectedCount = this.filteredResults.length;
    } else {
      this.filteredResults.forEach(result => {
        result['selected'] = false;
      });
      this.allSelected = false;
      this.selectedCount = 0;
    }
  }
  /*
    getKey(key) {
      this.Redis.getKey(key)
      .then(({ data }) => {
        this.results = data;
      })
      .catch(err => {
        this.results = [];
        this.$log.error(err);
      })
    }
  */


  checkFinish() {
    if (this.num_processed >= this.selectedCount) {
      if (this.poll) this.$interval.cancel(this.poll);
      this.processing = false;
      this.selectedCount = 0;
      this.getRedisCache();
    }
  }

  startFlush() {
    this.num_processed = 0;
    this.processing = true;
    this.poll = this.$interval(this.checkFinish.bind(this), 1000);
    this.filteredResults.forEach(result => {
      if (result['selected']) {
        this.Redis.flushKey(result.key).then(() => {
          this.num_processed++;
        }).catch(err => {
          this.num_processed++;
          console.log('Error: ' + JSON.stringify(err));
        });
      }
    });
  }

}

RedisCacheController.$inject = ["$log", "$http", "$interval", "Redis", "Users", "Auth", "Endpoints"];
angular.module('pims').controller('RedisCacheController', RedisCacheController);